import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const AccountingSettingService = {
  // --- Default Ledger Settings ---
  
  // Get all default ledger settings
  getDefaultLedgerSettings: async () => {
    try {
      const response = await instance.get("/accounting/default-ledger-settings", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching default ledger settings:", error);
      throw error;
    }
  },

  // Update a default ledger setting by key
  updateDefaultLedgerSetting: async (key, ledgerId) => {
    try {
      const response = await instance.put(`/accounting/default-ledger-settings/${key}`, { ledgerId }, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating default ledger setting for ${key}:`, error);
      throw error;
    }
  },

  // --- Auto Ledger Rules ---

  // Get all auto ledger settings (rules)
  getAutoLedgerSettings: async () => {
    try {
      // Endpoint name assumed based on context, standardizing to settings
      const response = await instance.get("/accounting/auto-ledger-rules", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching auto ledger settings:", error);
      throw error;
    }
  },

  // Update an auto ledger rule by ID
  updateAutoLedgerRule: async (id, data) => {
    try {
      // Request body includes: ledgerTypeId, nameTemplate, codeTemplate, isEnabled, description
      const response = await instance.put(`/accounting/auto-ledger-rules/${id}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating auto ledger rule ${id}:`, error);
      throw error;
    }
  },
};

export default AccountingSettingService;
